var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-full-preview"
  }, [_c('a', {
    staticClass: "card",
    attrs: {
      "href": _vm.article.url
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.article.image
    }
  }), _c('div', {
    staticClass: "card-info"
  }, [_c('small', [_vm._v(_vm._s(_vm.article.categoryData.name))]), _c('div', {
    staticClass: "name-container"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.original_name)
    }
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }